import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS_ENUM } from '../../static/query-keys.enum';
import { getWhatsappBroadcastDetail } from '../../api/broadcast';

export const useGetWhatsappBroadcastDetail = (id: string, enabled: boolean) => {
  return useQuery({
    queryKey: [QUERY_KEYS_ENUM.getEmailBroadcastDetail, id],
    enabled: !!id && enabled,
    queryFn: () => getWhatsappBroadcastDetail(id)
  });
};
